<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Control de Gestión</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            
            <b-col sm="3">
              <b-form-group :label="crearLabel('Fecha', 'fecha', 'datosFormulario')"
                          label-for="fecha" :horizontal="false">
                  <b-input-group>
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fecha"
                          :disabled="campoBloqueado('fecha', 'datosFormulario')">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fecha }}
                  </span>
                  </b-input-group>
              </b-form-group>    
                              
            </b-col>
             
          </b-row>

          <div slot="footer">
                <div class="form-actions">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Control de Gestión</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInformes from "@/components/services/apiInformes";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "ControlGestion",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      nombreexcel: "ControlGestion",
      titles: [
        {
          prop: "Ejecutivos",
          label: "Ejecutivos",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "Cantidad (General) ACT",
          label: "Cantidad (General) ACT",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "% Sin ACT",
          label: "% Sin ACT",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Años Anteriores ACT",
          label: "Años Anteriores ACT",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Año Antepasado ACT",
          label: "Año Antepasado ACT",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Año Pasado ACT",
          label: "Año Pasado ACT",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Año Actual ACT",
          label: "Año Actual ACT",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Póliza con Mov. ACT",
          label: "Póliza con Mov. ACT",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "% Pol ACT",
          label: "% Pol ACT",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Cantidad (General) PPA",
          label: "Cantidad (General) PPA",
          align: "right",
          minwidth:'230'
        },
        {
          prop: "% Sin PPA",
          label: "% Sin PPA",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Años Anteriores PPA",
          label: "Años Anteriores PPA",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Año Antepasado PPA",
          label: "Año Antepasado PPA",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Año Pasado PPA",
          label: "Año Pasado PPA",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Año Actual PPA",
          label: "Año Actual PPA",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Póliza con Mov. PPA",
          label: "Póliza con Mov. PPA",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "% Pol PPA",
          label: "% Pol PPA",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Desistidos Mes Actual",
          label: "Desistidos Mes Actual",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "% DES",
          label: "% DES",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Rechazado Mes Actual",
          label: "Rechazado Mes Actual",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "% REC",
          label: "% REC",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Sin. asig. Recuperos",
          label: "Sin. asig. Recuperos",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "% Recuperos",
          label: "% Recuperos",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Sin. asig. Fiscalía",
          label: "Sin. asig. Fiscalía",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "% Fiscalía",
          label: "% Fiscalía",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Sin. asig. Continental",
          label: "Sin. asig. Continental",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "% Continental",
          label: "% Continental",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Sin. asig. Liquidador",
          label: "Sin. asig. Liquidador",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "% Liquidador",
          label: "% Liquidador",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "Sin. Indemnizados",
          label: "Sin. Indemnizados",
          align: "right",
          minwidth:'150'
        },
        {
          prop: "% Sin. Indemnizados",
          label: "% Sin. Indemnizados",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Sin. Pagado Devolucion",
          label: "Sin. Pagado Devolucion",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "% Sin. Pagado Devolucion",
          label: "% Sin. Pagado Devolucion",
          align: "right",
          minwidth:'200'
        }
      ],
      filters: [
        {
          prop: ["Ejecutivos",
                 "Cantidad (General) ACT",
                 "% Sin ACT",
                 "Años Anteriores ACT",
                 "Año Antepasado ACT",
                 "Año Pasado ACT",
                 "Año Actual ACT",
                 "Póliza con Mov. ACT",
                 "% Pol ACT",
                 "Cantidad (General) PPA",
                 "% Sin PPA",
                 "Años Anteriores PPA",
                 "Año Antepasado PPA",
                 "Año Pasado PPA",
                 "Año Actual PPA",
                 "Póliza con Mov. PPA",
                 "% Pol PPA",
                 "Desistidos Mes Actual",
                 "% DES",
                 "Rechazado Mes Actual",
                 "% REC",
                 "Sin. asig. Recuperos",
                 "% Recuperos",
                 "Sin. asig. Fiscalía",
                 "% Fiscalía",
                 "Sin. asig. Continental",
                 "% Continental",
                 "Sin. asig. Liquidador",
                 "% Liquidador",
                 "Sin. Indemnizados",
                 "% Sin. Indemnizados",
                 "Sin. Pagado Devolucion",
                 "% Sin. Pagado Devolucion"
                 ],
          value: ""
        }
      ],

      mostrarFechas: true,
      datosFormulario: {},
      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: true,
          maxHeight: 400
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      return apiInformes
        .pre_insercion_ctrlgestion_area(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
            response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.fecha = lista_data[i]["fecha"];
          }
          
          this.datosFormularioEstado = response.data.festado;
          
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();      

      return apiInformes
        .recuperar_ctrlgestion_area(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.fecha
        )
        .then(response => {
          this.data  = response.data.res1;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          if (this.data != null){
            this.exportar = true;
          } else {
            this.exportar = false;
          }

        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if ((column.property == "Fecha"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      }
      else if ((column.property != "Ejecutivos"
        ) && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format('0,0.00');
        }
      }
      else {
        return row[column.property];
      }
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        //cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Control Gestión</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        //cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Fecha: "+this.datosFormulario.fecha+"</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i].label+"</td>\n";
        }
      cuerpo += "</tr>\n";


      var cont = 0;
      var sumdata1 = [];
      sumdata1["Cantidad (General) ACT"] = 0;
      sumdata1["% Sin ACT"] = 0;
      sumdata1["Años Anteriores ACT"] = 0;
      sumdata1["Año Antepasado ACT"] = 0;
      sumdata1["Año Pasado ACT"] = 0;
      sumdata1["Año Actual ACT"] = 0;
      sumdata1["Póliza con Mov. ACT"] = 0;
      sumdata1["% Pol ACT"] = 0;
      sumdata1["Cantidad (General) PPA"] = 0;
      sumdata1["% Sin PPA"] = 0;
      sumdata1["Años Anteriores PPA"] = 0;
      sumdata1["Año Antepasado PPA"] = 0;
      sumdata1["Año Pasado PPA"] = 0;
      sumdata1["Año Actual PPA"] = 0;
      sumdata1["Póliza con Mov. PPA"] = 0;
      sumdata1["% Pol PPA"] = 0;
      sumdata1["Desistidos Mes Actual"] = 0;
      sumdata1["% DES"] = 0;
      sumdata1["Rechazado Mes Actual"] = 0;
      sumdata1["% REC"] = 0;
      sumdata1["Sin. asig. Recuperos"] = 0;
      sumdata1["% Recuperos"] = 0;
      sumdata1["Sin. asig. Fiscalía"] = 0;
      sumdata1["% Fiscalía"] = 0;
      sumdata1["Sin. asig. Continental"] = 0;
      sumdata1["% Continental"] = 0;
      sumdata1["Sin. asig. Liquidador"] = 0;
      sumdata1["% Liquidador"] = 0;
      sumdata1["Sin. Indemnizados"] = 0;
      sumdata1["% Sin. Indemnizados"] = 0;
      sumdata1["Sin. Pagado Devolucion"] = 0;
      sumdata1["% Sin. Pagado Devolucion"] = 0;

      //Data bloque 1
      for (var key in this.data) {
          sumdata1["Cantidad (General) ACT"] += this.data[key]["Cantidad (General) ACT"];
          sumdata1["% Sin ACT"] += this.data[key]["% Sin ACT"];
          sumdata1["Años Anteriores ACT"] += this.data[key]["Años Anteriores ACT"];
          sumdata1["Año Antepasado ACT"] += this.data[key]["Año Antepasado ACT"];
          sumdata1["Año Pasado ACT"] += this.data[key]["Año Pasado ACT"];
          sumdata1["Año Actual ACT"] += this.data[key]["Año Actual ACT"];
          sumdata1["Póliza con Mov. ACT"] += this.data[key]["Póliza con Mov. ACT"];
          sumdata1["% Pol ACT"] += this.data[key]["% Pol ACT"];
          sumdata1["Cantidad (General) PPA"] += this.data[key]["Cantidad (General) PPA"];
          sumdata1["% Sin PPA"] += this.data[key]["% Sin PPA"];
          sumdata1["Años Anteriores PPA"] += this.data[key]["Años Anteriores PPA"];
          sumdata1["Año Antepasado PPA"] += this.data[key]["Año Antepasado PPA"];
          sumdata1["Año Pasado PPA"] += this.data[key]["Año Pasado PPA"];
          sumdata1["Año Actual PPA"] += this.data[key]["Año Actual PPA"];
          sumdata1["Póliza con Mov. PPA"] += this.data[key]["Póliza con Mov. PPA"];
          sumdata1["% Pol PPA"] += this.data[key]["% Pol PPA"];
          sumdata1["Desistidos Mes Actual"] += this.data[key]["Desistidos Mes Actual"];
          sumdata1["% DES"] += this.data[key]["% DES"];
          sumdata1["Rechazado Mes Actual"] += this.data[key]["Rechazado Mes Actual"];
          sumdata1["% REC"] += this.data[key]["% REC"];
          sumdata1["Sin. asig. Recuperos"] += this.data[key]["Sin. asig. Recuperos"];
          sumdata1["% Recuperos"] += this.data[key]["% Recuperos"];
          sumdata1["Sin. asig. Fiscalía"] += this.data[key]["Sin. asig. Fiscalía"];
          sumdata1["% Fiscalía"] += this.data[key]["% Fiscalía"];
          sumdata1["Sin. asig. Continental"] += this.data[key]["Sin. asig. Continental"];
          sumdata1["% Continental"] += this.data[key]["% Continental"];
          sumdata1["Sin. asig. Liquidador"] += this.data[key]["Sin. asig. Liquidador"];
          sumdata1["% Liquidador"] += this.data[key]["% Liquidador"];
          sumdata1["Sin. Indemnizados"] += this.data[key]["Sin. Indemnizados"];
          sumdata1["% Sin. Indemnizados"] += this.data[key]["% Sin. Indemnizados"];
          sumdata1["Sin. Pagado Devolucion"] += this.data[key]["Sin. Pagado Devolucion"];
          sumdata1["% Sin. Pagado Devolucion"] += this.data[key]["% Sin. Pagado Devolucion"];

          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            //cuerpo += "<td>&nbsp</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Ejecutivos"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Cantidad (General) ACT"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% Sin ACT"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Años Anteriores ACT"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Año Antepasado ACT"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Año Pasado ACT"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Año Actual ACT"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Póliza con Mov. ACT"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% Pol ACT"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Cantidad (General) PPA"]).format('0,0.00')+"</td>\n";

            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% Sin PPA"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Años Anteriores PPA"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Año Antepasado PPA"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Año Pasado PPA"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Año Actual PPA"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Póliza con Mov. PPA"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% Pol PPA"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Desistidos Mes Actual"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% DES"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Rechazado Mes Actual"]).format('0,0.00')+"</td>\n";

            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% REC"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Sin. asig. Recuperos"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% Recuperos"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Sin. asig. Fiscalía"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% Fiscalía"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Sin. asig. Continental"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% Continental"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Sin. asig. Liquidador"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% Liquidador"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Sin. Indemnizados"]).format('0,0.00')+"</td>\n";

            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% Sin. Indemnizados"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Sin. Pagado Devolucion"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% Sin. Pagado Devolucion"]).format('0,0.00')+"</td>\n";
          cuerpo += "</tr>\n";
      }

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl659618 style='height:15.0pt;border-top:none;border-left: none;"+xl659618+"'>Total</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Cantidad (General) ACT"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% Sin ACT"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Años Anteriores ACT"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Año Antepasado ACT"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Año Pasado ACT"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Año Actual ACT"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Póliza con Mov. ACT"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% Pol ACT"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Cantidad (General) PPA"]).format('0,0.00')+"</td>\n";
        
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% Sin PPA"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Años Anteriores PPA"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Año Antepasado PPA"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Año Pasado PPA"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Año Actual PPA"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Póliza con Mov. PPA"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% Pol PPA"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Desistidos Mes Actual"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% DES"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Rechazado Mes Actual"]).format('0,0.00')+"</td>\n";
        
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% REC"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Sin. asig. Recuperos"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% Recuperos"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Sin. asig. Fiscalía"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% Fiscalía"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Sin. asig. Continental"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% Continental"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Sin. asig. Liquidador"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% Liquidador"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Sin. Indemnizados"]).format('0,0.00')+"</td>\n";
        
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% Sin. Indemnizados"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["Sin. Pagado Devolucion"]).format('0,0.00')+"</td>\n";
        cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["% Sin. Pagado Devolucion"]).format('0,0.00')+"</td>\n";
      cuerpo += "</tr>\n";


      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();    
    //this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}
</style>
